<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M39.5 22.5h-14v-14a1.5 1.5 0 00-3 0v14h-14a1.5 1.5 0 000 3h14v14a1.5 1.5 0 003 0v-14h14a1.5 1.5 0 000-3z"/></svg>